import React, { useState, useEffect } from "react";
import PubModal from "Component/Modal/PubModal";
import { Link } from "react-router-dom";
import LikeButton from "Component/Liked/LikeButton";
import { useSelector } from "react-redux";

const CardNft = (props) => {
  const { getNftData, isLiked, getLikedPost } = props;
  const [isCurrentUser, setisCurrentUser] = useState(false);
  const [timer, setTimer] = useState({});

  const profile = useSelector((state) => state);

  useEffect(() => {
    if (profile?.Login?.user?._id == profile?.Profile?.userProfile?._id) {
      setisCurrentUser(true);
    } else {
      setisCurrentUser(false);
    }
  }, [profile?.Login, profile.Profile]);


  
  function calculateTimeLeft(leftDate) {
    let difference = +new Date(`${leftDate}`) - +new Date();
    let timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  }
  useEffect(() => {
    if ((props.isUpcoming, props.getNftData)) {
      let leftDate = props?.getNftData?.minted_start_date;
      const timer = setTimeout(() => {
        setTimer(calculateTimeLeft(leftDate));
      }, 1000);
      return () => clearTimeout(timer);
    }
  });

  return (
    <>
      {props.isUpcoming ? (
        (timer?.days > 0 ||
          timer?.hours > 0 ||
          timer?.minutes > 0 ||
          timer?.seconds > 0) && (
          <div className="digital-art-wrap position-relative">
            <Link to={`/bidding?id=${getNftData?._id}`} className="collect-art">
              <div className="digital-art-img position-relative">
                <img
                  src={getNftData?.media?.link}
                  alt="g"
                  className="img-fluid"
                />
              </div>
            </Link>

            <LikeButton
              liked={getNftData?.isLiked || isLiked}
              itemId={getNftData?._id}
              getLikedPost={getLikedPost}
            />

            <div className="digital-art-content">
              <Link
                to={`/bidding?id=${getNftData?._id}`}
                className="collect-art"
              >
                <div className="avatarwrap">
                  <div className="avatars">
                    <div className="avatars__item">
                      <div className="avatars__image">
                        <p>{getNftData?.name}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
              <div className="digital-price">
                <div className="price-here position-relative">
                  <div className="price-level">Price</div>
                  <p className="m-0 price-show">
                    {getNftData?.price}
                    <img src="images/dollor.png" className="polygon_icon" />
                  </p>
                </div>
                {getNftData?.current_owner?._id == profile?.Login?.user?._id ? (
                  <div className="price-time-here">
                    {isCurrentUser ? <PubModal item={getNftData} /> : null}
                  </div>
                ) : null}
              </div>
              {/* <div className="digital-price"> */}
              {JSON.stringify(timer) != "{}" && (
                <div className="price-time-here">
                  <div className="time_count_down_start">
                    <div className="flex flex-col-start ">
                      <span className="headings_text">
                        {timer?.days}
                        <br />
                      </span>
                      <span className="sub_text_start">Days</span>
                    </div>

                    <div className="flex flex-col-start ">
                      <span className="headings_text">
                        {timer?.hours}
                        <br />
                      </span>
                      <span className="sub_text_start">hours</span>
                    </div>

                    <div className="flex flex-col-start ">
                      <span className="headings_text">
                        {timer?.minutes}
                        <br />
                      </span>
                      <span className="sub_text_start">minutes</span>
                    </div>

                    <div className="flex flex-col-start ">
                      <span className="headings_text">
                        {timer?.seconds} <br />
                      </span>
                      <span className="sub_text_start">seconds</span>
                    </div>
                  </div>
                </div>
              )}
              {/* </div> */}
            </div>
          </div>
        )
      ) : (
        <div className="digital-art-wrap position-relative">
          <Link to={`/bidding?id=${getNftData?._id}`} className="collect-art">
            <div className="digital-art-img position-relative">
              <img
                src={getNftData?.media?.link}
                alt="g"
                className="img-fluid"
              />
            </div>
          </Link>

          <LikeButton
            liked={getNftData?.isLiked || isLiked}
            itemId={getNftData?._id}
            getLikedPost={getLikedPost}
          />

          <div className="digital-art-content">
            <Link to={`/bidding?id=${getNftData?._id}`} className="collect-art">
              <div className="avatarwrap">
                <div className="avatars">
                  <div className="avatars__item">
                    <div className="avatars__image">
                      <p>{getNftData?.name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div className="digital-price">
              <div className="price-here position-relative">
                <div className="price-level">Price</div>
                <p className="m-0 price-show">
                  {getNftData?.price}
                  <img src="images/dollor.png" className="polygon_icon" />
                </p>
              </div>
              {getNftData?.current_owner?._id == profile?.Login?.user?._id ? (
                <div className="price-time-here">
                  {isCurrentUser ? <PubModal item={getNftData} /> : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardNft;
